import { render, staticRenderFns } from "./RowspanTable.vue?vue&type=template&id=0f0ba706&scoped=true"
import script from "./RowspanTable.vue?vue&type=script&lang=js"
export * from "./RowspanTable.vue?vue&type=script&lang=js"
import style0 from "./RowspanTable.vue?vue&type=style&index=0&id=0f0ba706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ba706",
  null
  
)

export default component.exports